import { createLogic } from 'redux-logic';
import { GET_PRODUCTS_PENDING, FETCH_PRODUCT_IMAGE_URLS } from '../constants';
import { getProductsSuccess, getProductsError, fetchProductImageURLsSuccess, fetchProductImageURLsError  } from '../actions/AppActions';

export const fetchProductImageUrlsLogic = createLogic({
  type: FETCH_PRODUCT_IMAGE_URLS,
  validate({ action }, allow, reject) {
    const itemNumbers = action?.payload?.itemNumbers;
    if (Array.isArray(itemNumbers) && itemNumbers.length > 0) {
      allow(action);
    } else {
      reject(action);
    }
  },
  processOptions: {
    dispatchMultiple: true
  },
  process({ httpClient, action }, dispatch, done) {
    const itemNumbers = action?.payload?.itemNumbers;
    httpClient(dispatch).post('/product-images', itemNumbers)
      .then(res => {
        dispatch(fetchProductImageURLsSuccess({ data: res?.data }))
      })
      .catch(err => {
        dispatch(fetchProductImageURLsError(err));
      })
      .finally(() => done());
  }
});

export const fetchProductsByItemNumbersLogic = createLogic({
  type: GET_PRODUCTS_PENDING,
  validate({ action }, allow, reject) {
    const itemNumbers = action?.payload?.itemNumbers;
    if (Array.isArray(itemNumbers) && itemNumbers.length > 0) {
      allow(action);
    } else {
      reject(action);
    }
  },
  processOptions: {
    dispatchMultiple: true
  },
  process({ httpClient, action }, dispatch, done) {
    const itemNumbers = action?.payload?.itemNumbers;
    httpClient(dispatch).post('/product-images', itemNumbers)
      .then(res => {
        dispatch(getProductsSuccess({ type: action?.payload?.type, data: res?.data }));
        dispatch(fetchProductImageURLsSuccess({ data: res?.data }))
      })
      .catch(err => {
        dispatch(getProductsError(err));
      })
      .finally(() => done());
  }
});

export default [
  fetchProductImageUrlsLogic,
  fetchProductsByItemNumbersLogic,
];
